(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-dart/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-dart/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_dart = svs.themes.sport_dart || {};

  svs.themes.sport_dart.initStatusStart = function (data) {
    if (svs.themes.sport_dart.isLive(data.status.id)) {
      if (data.status.id === 13 || data.status.id === 115) {
        return '<div class="brick match-status brick-active f-condensed align-center">PÅGÅR</div>';
      } else if (data.status.id === 14) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      return '';
    } else if (svs.themes.sport_dart.isEnded(data.status.id)) {
      if (data.status.id === 25) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">INST</div>';
      } else if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_dart.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);